import React, { useState, useEffect } from "react";
import axios from "axios";
import "./templateEssayTest.css";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function TemplateEssayTest() {
  const [templates, setTemplates] = useState([]);
  const [essays, setEssays] = useState([]);
  const [newTemplate, setNewTemplate] = useState({
    teacher: "",
    template: {
      isHandwriting: false,
      title: "",
      description: "",
      questions: [],
    },
  });
  const [multipleTemplates, setMultipleTemplates] = useState({
    listflag: true,
    teacher: "",
    template: [
      {
        isHandwriting: false,
        title: "",
        description: "",
        questions: [],
      },
    ],
  });
  const [modifyTemplate, setModifyTemplate] = useState({
    template_id: "",
    isHandwriting: false,
    newcontents: {
      title: "",
      description: "",
      questions: [],
    },
  });
  const [deleteTemplateIds, setDeleteTemplateIds] = useState("");
  const [essayFilters, setEssayFilters] = useState({
    teacherid: "",
    studentid: "",
  });
  const [modifyEssay, setModifyEssay] = useState({
    essay_id: "",
    updated_essay_data: {
      question_responses: [],
    },
  });
  const [parseEssayData, setParseEssayData] = useState({
    teacher: "",
    student: "",
    handwritten: "-1",
    paperType: "4",
    numQuestions: "-1",
    moreInfo: "[]",
    pageNumbers: "[]",
    file: null,
  });
  const [gradeEssayId, setGradeEssayId] = useState("");

  // Template APIs
  const handleCreateTemplate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseURL}/savetemplates/`,
        newTemplate,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === "success") {
        alert(
          `Template created successfully! ID: ${response.data.template_id}`
        );
        fetchTemplates();
      }
    } catch (error) {
      alert("Error creating template: " + error.message);
    }
  };

  const handleCreateMultipleTemplates = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseURL}/savetemplates/`,
        multipleTemplates,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === "success") {
        alert(
          `Templates created successfully! IDs: ${response.data.template_id.join(
            ", "
          )}`
        );
        fetchTemplates();
      }
    } catch (error) {
      alert("Error creating templates: " + error.message);
    }
  };

  const fetchTemplates = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/seetemplates/`,
        {
          teacher: newTemplate.teacher,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setTemplates(response.data.templates || []);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const handleModifyTemplate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseURL}/modifytemplate/`,
        modifyTemplate,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === "success") {
        alert("Template modified successfully!");
        fetchTemplates();
      }
    } catch (error) {
      alert("Error modifying template: " + error.message);
    }
  };

  const handleDeleteTemplates = async (e) => {
    e.preventDefault();
    try {
      const template_ids = deleteTemplateIds
        .split(",")
        .map((id) => parseInt(id.trim()));
      const response = await axios.post(
        `${baseURL}/deltemplates/`,
        { template_ids },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      alert(response.data.message);
      if (response.data.status !== "error") {
        fetchTemplates();
      }
    } catch (error) {
      alert("Error deleting templates: " + error.message);
    }
  };

  // Essay APIs
  const fetchEssays = async () => {
    try {
      const params = {};
      if (essayFilters.teacherid) params.teacherid = essayFilters.teacherid;
      if (essayFilters.studentid) params.studentid = essayFilters.studentid;

      const response = await axios.get(`${baseURL}/getessays/`, { params });
      setEssays(response.data.essays || []);
    } catch (error) {
      console.error("Error fetching essays:", error);
    }
  };

  const handleModifyEssay = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseURL}/modifyessay/`,
        modifyEssay,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === "success") {
        alert(`Essay ${response.data.essay_id} modified successfully!`);
        console.log("Old data:", response.data.old_essay_data);
        console.log("New data:", response.data.new_essay_data);
        fetchEssays();
      } else {
        alert("Error: " + response.data.message);
      }
    } catch (error) {
      alert("Error modifying essay: " + error.message);
    }
  };

  // Handle essay parsing
  const handleParseEssay = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      const payload = {
        ...parseEssayData,
        teacher: String(parseEssayData.teacher),
        student: String(parseEssayData.student),
        handwritten: String(parseEssayData.handwritten),
        numQuestions: String(parseEssayData.numQuestions),
      };

      payload.moreInfo = JSON.stringify([
        {
          question: 0,
          max_marks: 10,
          max_words: 100,
          special_instructions: "Follow the guidelines",
          model_solution: "This is a model solution",
          candq: "What is this?",
        },
      ]);

      payload.pageNumbers = JSON.stringify([
        {
          question: 0,
          startPage: 1,
          endPage: 2,
        },
      ]);

      Object.entries(payload).forEach(([key, value]) => {
        if (key === "file") {
          if (value) formData.append(key, value);
        } else {
          formData.append(key, value);
        }
      });

      const response = await axios.post(`${baseURL}/parseessay/`, formData);
      if (response.data.status === "success") {
        alert(`Essay parsed successfully! Essay ID: ${response.data.essay_id}`);
        console.log("Essay data:", response.data.essay_data);
      } else {
        alert("Error: " + response.data.message);
      }
    } catch (error) {
      alert("Error parsing essay: " + error.message);
    }
  };

  const handleGradeEssay = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("essay_id", gradeEssayId);

      const response = await axios.post(`${baseURL}/gradeessay/`, formData);
      if (response.data.status === "success") {
        alert(`Essay ${response.data.essay_id} graded successfully!`);
        console.log("Updated essay data:", response.data.essay_data);
        fetchEssays();
      } else {
        alert(`Error: ${response.data.message}`);
      }
    } catch (error) {
      alert("Error grading essay: " + error.message);
    }
  };

  useEffect(() => {
    if (newTemplate.teacher) {
      fetchTemplates();
    }
  }, [newTemplate.teacher]);

  useEffect(() => {
    fetchEssays();
  }, [essayFilters.teacherid, essayFilters.studentid]);

  return (
    <div className="container">
      <h2>Template & Essay API Testing Interface</h2>

      {/* Template Section */}
      <div>
        <h3>Templates</h3>

        {/* Create Single Template */}
        <div>
          <h4>Create Template</h4>
          <form onSubmit={handleCreateTemplate}>
            <label>
              Teacher ID
              <input
                type="number"
                placeholder="Teacher ID"
                value={newTemplate.teacher}
                onChange={(e) =>
                  setNewTemplate((prev) => ({
                    ...prev,
                    teacher: e.target.value,
                  }))
                }
              />
            </label>
            <label>
              Title
              <input
                type="text"
                placeholder="Title"
                value={newTemplate.template.title}
                onChange={(e) =>
                  setNewTemplate((prev) => ({
                    ...prev,
                    template: { ...prev.template, title: e.target.value },
                  }))
                }
              />
            </label>
            <label>
              Description
              <input
                type="text"
                placeholder="Description"
                value={newTemplate.template.description}
                onChange={(e) =>
                  setNewTemplate((prev) => ({
                    ...prev,
                    template: { ...prev.template, description: e.target.value },
                  }))
                }
              />
            </label>
            <label>
              <input
                type="checkbox"
                checked={newTemplate.template.isHandwriting}
                onChange={(e) =>
                  setNewTemplate((prev) => ({
                    ...prev,
                    template: {
                      ...prev.template,
                      isHandwriting: e.target.checked,
                    },
                  }))
                }
              />
              Is Handwriting
            </label>
            <button type="submit">Create Template</button>
          </form>
        </div>

        {/* Create Multiple Templates */}
        <div>
          <h4>Create Multiple Templates</h4>
          <form onSubmit={handleCreateMultipleTemplates}>
            <input
              type="number"
              placeholder="Teacher ID"
              value={multipleTemplates.teacher}
              onChange={(e) =>
                setMultipleTemplates((prev) => ({
                  ...prev,
                  teacher: e.target.value,
                }))
              }
            />
            {multipleTemplates.template.map((template, index) => (
              <div key={index}>
                <input
                  type="text"
                  placeholder={`Template ${index + 1} Title`}
                  value={template.title}
                  onChange={(e) => {
                    const newTemplates = [...multipleTemplates.template];
                    newTemplates[index] = {
                      ...newTemplates[index],
                      title: e.target.value,
                    };
                    setMultipleTemplates((prev) => ({
                      ...prev,
                      template: newTemplates,
                    }));
                  }}
                />
                <input
                  type="checkbox"
                  checked={template.isHandwriting}
                  onChange={(e) => {
                    const newTemplates = [...multipleTemplates.template];
                    newTemplates[index] = {
                      ...newTemplates[index],
                      isHandwriting: e.target.checked,
                    };
                    setMultipleTemplates((prev) => ({
                      ...prev,
                      template: newTemplates,
                    }));
                  }}
                />
                <label>Is Handwriting</label>
              </div>
            ))}
            <button
              type="button"
              onClick={() =>
                setMultipleTemplates((prev) => ({
                  ...prev,
                  template: [
                    ...prev.template,
                    {
                      isHandwriting: false,
                      title: "",
                      description: "",
                      questions: [],
                    },
                  ],
                }))
              }
            >
              Add Template
            </button>
            <button type="submit">Create Templates</button>
          </form>
        </div>

        {/* Modify Template */}
        <div>
          <h4>Modify Template</h4>
          <form onSubmit={handleModifyTemplate}>
            <input
              type="number"
              placeholder="Template ID"
              value={modifyTemplate.template_id}
              onChange={(e) =>
                setModifyTemplate((prev) => ({
                  ...prev,
                  template_id: e.target.value,
                }))
              }
            />
            <input
              type="checkbox"
              checked={modifyTemplate.isHandwriting}
              onChange={(e) =>
                setModifyTemplate((prev) => ({
                  ...prev,
                  isHandwriting: e.target.checked,
                }))
              }
            />
            <label>Is Handwriting</label>
            <button type="submit">Modify Template</button>
          </form>
        </div>

        {/* Delete Templates */}
        <div>
          <h4>Delete Templates</h4>
          <form onSubmit={handleDeleteTemplates}>
            <input
              type="text"
              placeholder="Template IDs (comma-separated)"
              value={deleteTemplateIds}
              onChange={(e) => setDeleteTemplateIds(e.target.value)}
            />
            <button type="submit">Delete Templates</button>
          </form>
        </div>

        {/* Display Templates */}
        <div>
          <h4>All Templates</h4>
          <button onClick={fetchTemplates}>Refresh Templates</button>
          <div>
            {templates.map((template, index) => (
              <div key={index} className="template-item">
                <pre>{JSON.stringify(template, null, 2)}</pre>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Essay Section */}
      <div>
        <h3>Essays</h3>

        {/* Parse Essay */}
        <div>
          <h4>Parse Essay</h4>
          <form onSubmit={handleParseEssay}>
            <label>
              Teacher ID
              <input
                type="number"
                placeholder="Teacher ID"
                value={parseEssayData.teacher}
                onChange={(e) =>
                  setParseEssayData((prev) => ({
                    ...prev,
                    teacher: e.target.value,
                  }))
                }
                required
              />
            </label>
            <label>
              Student ID
              <input
                type="number"
                placeholder="Student ID"
                value={parseEssayData.student}
                onChange={(e) =>
                  setParseEssayData((prev) => ({
                    ...prev,
                    student: e.target.value,
                  }))
                }
                required
              />
            </label>
            <label>
              Handwritten
              <select
                value={parseEssayData.handwritten}
                onChange={(e) =>
                  setParseEssayData((prev) => ({
                    ...prev,
                    handwritten: e.target.value,
                  }))
                }
              >
                <option value="-1">Ambiguous</option>
                <option value="0">Typed</option>
                <option value="1">Handwritten</option>
              </select>
            </label>
            <label>
              Paper Type
              <input
                type="text"
                placeholder="Paper Type (default: 5)"
                value={parseEssayData.paperType}
                onChange={(e) =>
                  setParseEssayData((prev) => ({
                    ...prev,
                    paperType: e.target.value,
                  }))
                }
              />
            </label>
            <label>
              Number of Questions
              <input
                type="number"
                placeholder="Number of Questions (default: -1)"
                value={parseEssayData.numQuestions}
                onChange={(e) =>
                  setParseEssayData((prev) => ({
                    ...prev,
                    numQuestions: e.target.value,
                  }))
                }
              />
            </label>
            <label>
              More Info
              <textarea
                placeholder='[{"question": 1, "metadata": "example"}]'
                value={parseEssayData.moreInfo}
                onChange={(e) =>
                  setParseEssayData((prev) => ({
                    ...prev,
                    moreInfo: e.target.value,
                  }))
                }
              />
            </label>
            <label>
              Page Numbers
              <textarea
                placeholder='[{"question": 1, "startPage": 1, "endPage": 2}]'
                value={parseEssayData.pageNumbers}
                onChange={(e) =>
                  setParseEssayData((prev) => ({
                    ...prev,
                    pageNumbers: e.target.value,
                  }))
                }
              />
            </label>
            <label>
              File
              <input
                type="file"
                accept=".pdf"
                onChange={(e) =>
                  setParseEssayData((prev) => ({
                    ...prev,
                    file: e.target.files[0],
                  }))
                }
                required
              />
            </label>
            <button type="submit">Parse Essay</button>
          </form>
        </div>

        {/* Grade Essay */}
        <div>
          <h4>Grade Essay</h4>
          <form onSubmit={handleGradeEssay}>
            <input
              type="number"
              placeholder="Essay ID"
              value={gradeEssayId}
              onChange={(e) => setGradeEssayId(e.target.value)}
              required
            />
            <button type="submit">Grade Essay</button>
          </form>
        </div>

        {/* Display Essays */}
        <div>
          <h4>All Essays</h4>
          <div>
            <input
              type="number"
              placeholder="Filter by Teacher ID"
              value={essayFilters.teacherid}
              onChange={(e) =>
                setEssayFilters((prev) => ({
                  ...prev,
                  teacherid: e.target.value,
                }))
              }
            />
            <input
              type="number"
              placeholder="Filter by Student ID"
              value={essayFilters.studentid}
              onChange={(e) =>
                setEssayFilters((prev) => ({
                  ...prev,
                  studentid: e.target.value,
                }))
              }
            />
            <button onClick={fetchEssays}>Refresh Essays</button>
          </div>
          <div>
            {essays.map((essay, index) => (
              <div key={index} className="essay-item">
                <pre>{JSON.stringify(essay, null, 2)}</pre>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
